import SecondaryCardContent from './SecondaryCardContent';

export default SecondaryCardContent;
